var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useCallback, useRef } from "react";
import { CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
var DEFAULT_LIMIT = 100;
export function useLogsFetcher(_a) {
    var _this = this;
    var accountId = _a.accountId;
    var _b = useState([]), logs = _b[0], setLogs = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), loadingMore = _d[0], setLoadingMore = _d[1];
    var _e = useState(null), error = _e[0], setError = _e[1];
    var _f = useState(false), hasMore = _f[0], setHasMore = _f[1];
    var _g = useState(null), oldestFetchedTs = _g[0], setOldestFetchedTs = _g[1];
    var _h = useState(null), legacyText = _h[0], setLegacyText = _h[1];
    // Track current range for fetchMore
    var rangeRef = useRef({
        from: 0,
        to: 0,
        limit: DEFAULT_LIMIT,
    });
    // Track the earliest timestamp we've fetched so far for cursor-based pagination
    var cursorRef = useRef(null);
    var callApi = useCallback(function (from, to, limit) { return __awaiter(_this, void 0, Promise, function () {
        var getSubdomainLogs, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    getSubdomainLogs = CloudFunctions.httpsCallable("oncall");
                    return [4 /*yield*/, getSubdomainLogs({
                            name: "getSubdomainLogs",
                            data: {
                                accountId: accountId,
                                from: from,
                                to: to,
                                limit: limit,
                            },
                        })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    }); }, [accountId]);
    var fetchLogs = useCallback(function (from_1, to_1) {
        var args_1 = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args_1[_i - 2] = arguments[_i];
        }
        return __awaiter(_this, __spreadArray([from_1, to_1], args_1, true), void 0, function (from, to, limit) {
            var result, data, entries, oldest, oldestTs, err_1;
            if (limit === void 0) { limit = DEFAULT_LIMIT; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        setError(null);
                        setLogs([]);
                        setLegacyText(null);
                        setHasMore(false);
                        setOldestFetchedTs(null);
                        cursorRef.current = null;
                        rangeRef.current = { from: from, to: to, limit: limit };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, callApi(from, to, limit)];
                    case 2:
                        result = _a.sent();
                        // Legacy accounts return a plain string
                        if (typeof result === "string") {
                            setLegacyText(result);
                            setHasMore(false);
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        data = result;
                        entries = data.entries || [];
                        // Sort entries descending by createdAt (newest first)
                        entries.sort(function (a, b) { return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(); });
                        setLogs(entries);
                        setHasMore(data.hasMore);
                        // Set cursor to the oldest entry's timestamp for pagination
                        if (entries.length > 0) {
                            oldest = entries[entries.length - 1];
                            oldestTs = new Date(oldest.createdAt).getTime();
                            cursorRef.current = oldestTs;
                            setOldestFetchedTs(oldestTs);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        setError(err_1.message || "Failed to fetch logs");
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [callApi]);
    var fetchMore = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var toTimestamp, fromTimestamp, result, data, entries_1, oldest, oldestTs, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hasMore || loadingMore || loading)
                        return [2 /*return*/];
                    if (cursorRef.current === null)
                        return [2 /*return*/];
                    setLoadingMore(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    toTimestamp = cursorRef.current - 1;
                    fromTimestamp = rangeRef.current.from;
                    if (toTimestamp <= fromTimestamp) {
                        setHasMore(false);
                        setLoadingMore(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, callApi(fromTimestamp, toTimestamp, rangeRef.current.limit)];
                case 2:
                    result = _a.sent();
                    if (typeof result === "string") {
                        setHasMore(false);
                        setLoadingMore(false);
                        return [2 /*return*/];
                    }
                    data = result;
                    entries_1 = data.entries || [];
                    if (entries_1.length === 0) {
                        setHasMore(false);
                        setLoadingMore(false);
                        return [2 /*return*/];
                    }
                    // Sort new entries descending
                    entries_1.sort(function (a, b) { return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(); });
                    setLogs(function (prev) { return __spreadArray(__spreadArray([], prev, true), entries_1, true); });
                    setHasMore(data.hasMore);
                    oldest = entries_1[entries_1.length - 1];
                    oldestTs = new Date(oldest.createdAt).getTime();
                    cursorRef.current = oldestTs;
                    setOldestFetchedTs(oldestTs);
                    return [3 /*break*/, 5];
                case 3:
                    err_2 = _a.sent();
                    setError(err_2.message || "Failed to fetch more logs");
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingMore(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [hasMore, loadingMore, loading, callApi]);
    var reset = useCallback(function () {
        setLogs([]);
        setLoading(false);
        setLoadingMore(false);
        setError(null);
        setHasMore(false);
        setOldestFetchedTs(null);
        setLegacyText(null);
        cursorRef.current = null;
    }, []);
    return { logs: logs, loading: loading, loadingMore: loadingMore, error: error, hasMore: hasMore, oldestFetchedTimestamp: oldestFetchedTs, legacyText: legacyText, fetchLogs: fetchLogs, fetchMore: fetchMore, reset: reset };
}
